module.exports = __webpack_public_path__ + "media/unipod/pod_construciton_2-a836cf68.jpg";